// extracted by mini-css-extract-plugin
export default {"container":"UnorganizedView-module__container--RcQtt","animatedBackground":"UnorganizedView-module__animatedBackground--PLKOf"};